import makeStyles from '@material-ui/core/styles/makeStyles';

const styles = makeStyles(() => ({
  tableContainer: {
    position: 'relative',
    width: '100%',
  },

  checkbox: {
    padding: 4,
  },

  thumbsUp: {
    fontSize: 18,
    cursor: 'pointer',
  },

  thumbsDown: {
    fontSize: 18,
    cursor: 'pointer',
    marginLeft: 8,
  },

  buttonMore: {
    fontSize: 32,
    width: 32,
    height: 30,
    lineHeight: '32px',
  },
}));

export default styles;
